// extracted by mini-css-extract-plugin
module.exports = {"box":"pager-module--box--1cnd8","page":"pager-module--page--1pRhB","active":"pager-module--active--3-xvs"};